import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Resource, ResourceStatus } from "../../../../models/resource";
import { memo } from "react";

interface PublishResourceDialogInterface {
    resource: Resource;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    updateResource: (resource: Resource) => Promise<void>; 
}

function PublishResourceDialog({ resource, open, setOpen, updateResource}: PublishResourceDialogInterface) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="first-resource-publish-dialog-title"
            aria-describedby="first-resource-publish-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                    overflow: 'visible'
                }
            }}
        >
            <DialogTitle id="first-resource-publish-dialog-title" sx={{ fontWeight: 'bold' }} >
                Publish Resource
            </DialogTitle>

             <DialogContent>
                <DialogContentText 
                    id="delete-resource-dialog-description" 
                    sx={{ 
                        color: 'text.secondary',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                    }}
                >
                    By publishing this resource for the first time, Students will be notified and have access to it only if this collection
                    is published.
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                 <Button
                    onClick={() => setOpen(false)}
                    variant="outlined"
                    sx={{ 
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 500,
                        px: 3,
                        py: 1,
                        borderColor: '#d1d5db',
                        color: '#6b7280',
                        '&:hover': {
                            borderColor: '#9ca3af',
                            backgroundColor: '#f9fafb'
                        }
                    }}
                >
                    Cancel
                </Button>

                 <Button
                    onClick={() => {
                        setOpen(false);     
                        const newRes = {
                            ...resource,
                            status: ResourceStatus.PUBLISHED
                        }
                        updateResource(newRes);
                    }}
                    variant="contained"
                    sx={{ 
                        backgroundColor: "#10b981",
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 4,
                        py: 1,
                        boxShadow: '0 4px 12px -2px rgba(16, 185, 129, 0.3)',
                        '&:hover': {
                            backgroundColor: "#059669",
                            boxShadow: '0 8px 20px -4px rgba(16, 185, 129, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Publish
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default memo(PublishResourceDialog);